<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-card header-tag="header" header-bg-variant="dark">
            <template #header>
              <p class="mb-0" style="">
                <strong>{{ $store.state.table.pelamar }}</strong>
              </p>
            </template>
            <b-tabs v-model="activeTab" content-class="mt-3" align="center">
              <b-tab active :title="$store.state.tab.pelamar">
                <pelamar @changeVar="changeVar" :activeTab="activeTab" />
              </b-tab>
              <b-tab :title="$store.state.tab.pelamarditolak">
                <reject @changeVar="changeVar" :refreshDitolak="refreshDitolak" :activeTab="activeTab" />
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import pelamar from "./pelamarKerja/pelamarKerja.vue";
import reject from "./pelamarKerjaDitolak/pelamarKerjaDitolak";

export default {
  components: {
    pelamar,
    reject,
  },
  name: "pelamarKerja",
  data() {
    return {
      refreshDitolak: false,
      activetab: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
